import { render, staticRenderFns } from "./Competitions.vue?vue&type=template&id=aac9453c&scoped=true&lang=html&"
import script from "./Competitions.vue?vue&type=script&lang=js&"
export * from "./Competitions.vue?vue&type=script&lang=js&"
import style0 from "./Competitions.vue?vue&type=style&index=0&id=aac9453c&lang=scss&scoped=true&"
import style1 from "./Competitions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac9453c",
  null
  
)

export default component.exports